export const SORT_OPTIONS = [
  { value: 'name', from: 'A', to: 'Z' },
  { value: '-name', from: 'Z', to: 'A' },
  { value: '-modified', label: 'Newest first' },
  { value: 'modified', label: 'Oldest first' },
];
